import { Component, inject, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemeService } from '../shared/theme.service';

@Component({
  selector: 'vb-lxp-theme-toggle',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './vb-lxp-theme-toggle.component.html',
  styleUrls: ['./vb-lxp-theme-toggle.component.css'],
})
export class VbLxpThemeToggleComponent {
  public themeService = inject(ThemeService);

  public buttonClass = input<string>('');

  public iconSize = input<number>(24);

  public title = input<string>('Toggle Light/Dark Theme');

  public showLabel = input<boolean>(false);

  public lightLabel = input<string>('Light');

  public darkLabel = input<string>('Dark');

  public themeChanged = output<boolean>();

  public onThemeToggle(): void {
    this.themeService.toggleDarkMode();
    this.themeChanged.emit(this.themeService.isDarkMode());
  }
}
